import { sizes as bannerImageSizes, wrapBannerImageSrc } from './urlMappings/bannerImageMappings';
import { sizes as communityContentImageSizes, wrapCommunityContentImageSrc, } from './urlMappings/communityContentImageMappings';
import { sizes as defaultImageSizes, wrapDefaultImageSrc } from './urlMappings/defaultImageMappings';
import { sizes as personalizedRecommendationsImageSizes, wrapPersonalizedRecommendationsImageSrc, } from './urlMappings/personalizedRecommendationsImageMappings';
import { sizes as resellImageSizes, wrapProductImageImageManagerImageSrc, } from './urlMappings/productImageImageManagerMappings';
import { sizes as productImageSizes, wrapProductImageSrc } from './urlMappings/productImageMappings';
import { sizes as quizImageImageSizes, wrapQuizImageImageSrc, } from './urlMappings/quizImageImageMappings';
import { sizes as rewardSummaryImageSizes, wrapRewardSummaryImageSrc, } from './urlMappings/rewardSummaryImageMappings';
import { sizes as teaserImageSizes, wrapTeaserImageSrc } from './urlMappings/teaserImageMappings';
export const imageTypes = {
    DEFAULT_IMAGE: 'DEFAULT_IMAGE',
    PRODUCT_IMAGE: 'PRODUCT_IMAGE',
    COMMUNITY_CONTENT_IMAGE: 'COMMUNITY_CONTENT_IMAGE',
    PERSONALIZED_RECOMMENDATIONS_IMAGE: 'PERSONALIZED_RECOMMENDATIONS_IMAGE',
    QUIZ_IMAGE: 'QUIZ_IMAGE',
    BANNER_IMAGE: 'BANNER_IMAGE',
    TEASER_IMAGE: 'TEASER_IMAGE',
    NO_TRANSFORM_IMAGE: 'NO_TRANSFORM_IMAGE',
    REWARD_SUMMARY_IMAGE: 'REWARD_SUMMARY_IMAGE',
    RESELL_IMAGE: 'RESELL_IMAGE',
    RENTALS_LOOK_BOOK_IMAGE: 'RENTALS_LOOK_BOOK_IMAGE',
    HERO_IMAGE: 'HERO_IMAGE',
    PERSONALIZED_CATEGORY_IMAGE: 'PERSONALIZED_CATEGORY_IMAGE',
};
const imageUrlTypeMappings = {
    [imageTypes.DEFAULT_IMAGE]: [defaultImageSizes, wrapDefaultImageSrc],
    [imageTypes.PRODUCT_IMAGE]: [productImageSizes, wrapProductImageSrc],
    [imageTypes.COMMUNITY_CONTENT_IMAGE]: [communityContentImageSizes, wrapCommunityContentImageSrc],
    [imageTypes.PERSONALIZED_RECOMMENDATIONS_IMAGE]: [
        personalizedRecommendationsImageSizes,
        wrapPersonalizedRecommendationsImageSrc,
    ],
    [imageTypes.BANNER_IMAGE]: [bannerImageSizes, wrapBannerImageSrc],
    [imageTypes.TEASER_IMAGE]: [teaserImageSizes, wrapTeaserImageSrc],
    [imageTypes.QUIZ_IMAGE]: [quizImageImageSizes, wrapQuizImageImageSrc],
    [imageTypes.REWARD_SUMMARY_IMAGE]: [rewardSummaryImageSizes, wrapRewardSummaryImageSrc],
    [imageTypes.RESELL_IMAGE]: [resellImageSizes, wrapProductImageImageManagerImageSrc],
    // use resellImageSizes as is
    [imageTypes.RENTALS_LOOK_BOOK_IMAGE]: [resellImageSizes, wrapProductImageImageManagerImageSrc],
    [imageTypes.HERO_IMAGE]: [resellImageSizes, wrapProductImageImageManagerImageSrc],
    [imageTypes.PERSONALIZED_CATEGORY_IMAGE]: [
        resellImageSizes,
        wrapProductImageImageManagerImageSrc,
    ],
};
export const getImageUrlBasedOnContainerWidth = ({ src, type = imageTypes.DEFAULT_IMAGE, containerWidth, useDevPrefixedUrl, }) => {
    if (type === imageTypes.NO_TRANSFORM_IMAGE)
        return src;
    if (!imageUrlTypeMappings[type]) {
        const imageTypeString = Object.values(imageTypes).join(', ');
        throw new Error(`image type '${type}' not supported, available types: ${imageTypeString}`);
    }
    const [sizes, wrapImageUrl] = imageUrlTypeMappings[type];
    const closestImageWidth = sizes.find((size) => containerWidth <= size) || sizes[sizes.length - 1];
    // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
    return wrapImageUrl(src, closestImageWidth, useDevPrefixedUrl);
};
export const getResellImageUrl = (url) => {
    if (url.includes('https://sellpy-parse-prod-files.s3.amazonaws.com')) {
        return url.replace('https://sellpy-parse-prod-files.s3.amazonaws.com/', '/resell/');
    }
    if (url.includes('https://hm.cdn.sellpy.net')) {
        return url.replace('https://hm.cdn.sellpy.net/', '/resell/');
    }
    return url;
};
//# sourceMappingURL=getImageUrl.js.map